import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { ITemplateEmailNotificationVariableApi, GetVariablesRequest } from './base/templateEmailNotificationVariableApi';
import { TemplateEmailNotificationVariableResponse } from '../models/response/templateEmailNotificationResponse';

const baseRoute: string = 'TemplateEmailNotificationVariable';

export class TemplateEmailNotificationVariableApi extends ITemplateEmailNotificationVariableApi {
  getVariables(request: GetVariablesRequest): Promise<AxiosResponse<Result<TemplateEmailNotificationVariableResponse[]>>> {
    return api.get(`${baseRoute}/get-variables`, { params: request });
  }
}
